/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Prompt_Placeholder_KnowInputs */



/**
* | output |
* | --- |
* | "What would you like to know?" |
*
* @param {Chat_Prompt_Placeholder_KnowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_prompt_placeholder_know = /** @type {((inputs?: Chat_Prompt_Placeholder_KnowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Prompt_Placeholder_KnowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was möchtest du wissen?")
	return /** @type {LocalizedString} */ ("What would you like to know?")
});